import { FieldPath, useFormContext } from "react-hook-form";
import { produce } from "immer";
import { TemplateSection } from "./TestResultsTemplate";
import { TestEventResults, TestResult, WelderResults } from "@/api/williams/testEvents";

import styles from "./TestResults.module.css";

type WelderSectionProps = {
  welder: WelderResults;
  path: FieldPath<TestEventResults>;
  isLocked: boolean;
};

export function WelderSection({ welder, path, isLocked }: WelderSectionProps) {
  const form = useFormContext<TestEventResults>();
  const allPassed = welder.templates.every((template) => template.result === TestResult.Pass);

  function handlePassAll(e: React.ChangeEvent<HTMLInputElement>) {
    const result = e.currentTarget.checked ? TestResult.Pass : TestResult.None;
    const updatedWelder = produce(welder, (draft) => {
      for (const template of draft.templates.filter((x) => !x.submitted)) {
        template.result = result;
        for (const segment of template.segments) {
          segment.result = result;
          for (const test of segment.tests) {
            test.result = result;
          }
        }
      }
    });

    form.setValue(path, updatedWelder, {
      shouldDirty: true,
    });
  }

  return (
    <div className="border py-4 px-2 px-md-4 mb-3">
      <div className="d-flex justify-content-between align-items-center">
        <span className="fw-bold h4 m-0">{welder.welderName}</span>
        <div className="form-check form-check-reverse mb-0 me-1">
          <label htmlFor="passAll">Pass All</label>
          <input
            id="passAll"
            type="checkbox"
            className="form-check-input"
            checked={allPassed}
            onChange={handlePassAll}
            disabled={welder.templates.every((x) => x.submitted) || isLocked}
          />
        </div>
      </div>
      <hr />

      <div className="p-1">
        <div className="d-flex justify-content-between fw-bold small">
          <div>Template</div>
          <div className="d-flex gap-2 text-center">
            <div className={styles.field}>
              Test<span className="d-none d-md-inline">/Weld</span> Date
            </div>
            <div className={styles.field}>Result</div>
          </div>
        </div>

        {welder.templates.map((template, index) => (
          <TemplateSection
            key={template.recordId}
            welder={welder}
            template={template}
            isLocked={isLocked}
            path={`${path}.templates.${index}` as FieldPath<TestEventResults>}
          />
        ))}
      </div>
    </div>
  );
}
